module.exports = __webpack_public_path__ + "static/img/shoujoubae_ka.88ff1bf.jpg";